var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4058 0H1.40576C1.14055 0 0.886191 0.105357 0.698655 0.292893C0.511119 0.48043 0.405762 0.734784 0.405762 1V17C0.405762 17.2652 0.511119 17.5196 0.698655 17.7071C0.886191 17.8946 1.14055 18 1.40576 18H10.0208V11.04H7.68276V8.315H10.0208V6.315C10.0208 3.99 11.4408 2.723 13.5208 2.723C14.2198 2.721 14.9198 2.757 15.6158 2.83V5.25H14.1808C13.0528 5.25 12.8328 5.788 12.8328 6.575V8.31H15.5298L15.1798 11.035H12.8318V18H17.4058C17.671 18 17.9253 17.8946 18.1129 17.7071C18.3004 17.5196 18.4058 17.2652 18.4058 17V1C18.4058 0.734784 18.3004 0.48043 18.1129 0.292893C17.9253 0.105357 17.671 0 17.4058 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1c513510c676406a11d178a29ad2cc4d.svg";
export { ForwardRef as ReactComponent };